<template>
  <div class="classify">
    <navbar left-text show-home title="分类" />
    <div class="classify-wrapper">
      <div class="search">
        <button @click="onSearch" class="search-bar">
          <img alt src="../assets/img/search.png" />
          <span>搜索</span>
        </button>
      </div>
      <div class="classify-container van-hairline--top">
        <div class="classify-nav" ref="navWrapper">
          <ul class="classify-nav-wrapper">
            <li
              :class="current === index ? 'active' : ''"
              :key="index"
              v-for="(item, index) in classifyList"
            >
              <button @click="switchTab(index)">{{item.name}}</button>
            </li>
          </ul>
        </div>
        <div class="classify-nav-second" ref="secondNavWrapper">
          <ul class="classify-nav-second-wrapper">
            <li
              :key="index"
              class="second-classify"
              v-for="(secondClassify, index) in secondClassifyList"
            >
              <div class="second-classify-name">{{secondClassify.name}}</div>
              <ul class="third-classify">
                <li :key="index" v-for="(thirdClassify, index) in secondClassify.list">
                  <a
                    @click="jumpDetails(thirdClassify.id)"
                    class="third-classify-entry"
                    href="javascript:;"
                  >
                    <div class="classify-img van-hairline--surround">
                      <img v-lazy="thirdClassify.pic_url" />
                    </div>
                    <span>{{thirdClassify.name}}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <transition name="fade-in">
      <component :is="componentId" @close="closeSearch" v-model="showSearch"></component>
    </transition>
  </div>
</template>

<script>
import Bsroll from 'better-scroll'
import Navbar from '../components/NavBar'
import Search from '../components/SearchForProduct'
let flag = false
export default {
  name: 'classify',
  components: {
    Navbar,
    Search
  },
  data () {
    return {
      classifyList: [], // window._CATEGORY_TREE,
      current: 0,
      selected: 0,
      secondClassifyList: [],
      componentId: null,
      showSearch: false
    }
  },
  watch: {
    current (newVal) {
      this.getSecondCliassfy(this.classifyList[newVal].id)
    }
  },
  created () {
    this.getFirstClassify().then(() => {
      this.getSecondCliassfy(this.classifyList[0].id)
    })
  },
  mounted () {
    this.initScroll()
  },
  methods: {
    onSearch (e) {
      if (flag) {
        return false
      }
      flag = true
      this.$router.push({ name: 'searchPage' })
      flag = false
    },
    closeSearch () {
      this.componentId = null
      this.showSearch = false
    },
    switchTab (i) {
      this.current = i
      this.contScroll.scrollTo(0, 0)
    },
    initScroll () {
      this.$nextTick(() => {
        this.scroll = new Bsroll(this.$refs.navWrapper, {
          click: true
        })
        this.contScroll = new Bsroll(this.$refs.secondNavWrapper, {
          click: true
        })
      })
    },

    /**
     * 获取一级分类
    */
    async getFirstClassify () {
      const res = await this.$axios.get('/api/goods/categories')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.classifyList = data
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 获取二级分类
     * @param([Number, String]) id 一级分类id
    */
    async getSecondCliassfy (id) {
      this.$toast.loading({ message: '正在加载...', duration: 300000, forbidClick: true })
      const res = await this.$axios.get(`api/goods/categories/${id}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.secondClassifyList = data
        } else if (code === 9006) {

        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 跳转到分类详情
     * @param([Number, String]) id 三级分类id
    */
    jumpDetails (id) {
      this.$router.push({ name: 'classifyDetails', query: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
.classify {
  .search {
    padding: 0.14rem 0.24rem;
    background-color: #fff;
    text-align: center;
    font-size: @fz24;
    color: @c80;
    .search-bar {
      width: 100%;
      height: 0.6rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      background-color: #fff;
      border-radius: 30px;
      border: 0.6px solid #ccc;
      border-radius: 0.6rem;
      box-sizing: border-box;
      img {
        width: 0.3rem;
        object-fit: contain;
        padding-left: 0.2rem;
        padding-right: 0.1rem;
      }
    }
  }
  .classify-container {
    position: absolute;
    font-size: @fz24;
    top: 1.76rem;
    bottom: 0rem;
    left: 0;
    right: 0;
    .flex-between;
    overflow: hidden;
  }
  .classify-nav {
    // position: absolute;
    // top: 0;
    // bottom: 0;
    height: 100%;
    background-color: #f5f5f5;
    .classify-nav-wrapper {
      padding: 0.2rem 0;
      li {
        margin-bottom: 0.2rem;
        button {
          width: 1.76rem;
          padding: 0.1rem 0;
          border-left: 0.06rem solid transparent;
        }
        &.active {
          button {
            border-color: #ff6180;
            background-color: #fff;
            box-sizing: border-box;
          }
        }
      }
    }
  }
  .classify-nav-second {
    width: 5.74rem;
    height: 100%;
    font-size: @fz24;
    color: @base;
    // padding: 0.25rem 0;
    background-color: #fff;
    .classify-nav-second-wrapper {
      .second-classify {
        padding: 0 0.3rem;
        border-bottom: 0.18rem solid #f8f8f8;
        background-color: #fff;
        &:last-child {
          border-bottom: none;
        }
        .second-classify-name {
          padding-top: 0.25rem;
        }
      }
      .third-classify {
        padding-bottom: 0.35rem;
        // .flex-between;
        display: flex;
        flex-wrap: wrap;
        li {
          margin-top: 0.35rem;
          width: 1.4rem;
          text-align: center;
          &:nth-child(3n-1) {
            margin: 0.35rem 0.45rem 0;
          }
        }
      }
      .third-classify-entry {
        .flex-column-center;
        color: @base;
      }
      .classify-img {
        width: 1.4rem;
        height: 1.4rem;
        margin-bottom: 0.25rem;
      }
    }
  }
}
</style>
